import React from 'react';

const UserNotesDashboard = (props) => {
  return (
    <>
      <div className="flex justify-center items-center w-full text-xl font-bold text-[#005C6A] opacity-30 cursor-pointer">
        {' '}
        No Notes Uploded{' '}
      </div>
    </>
  );
};

export default UserNotesDashboard;
